import { Button } from '@byte-design/ui';
import { observer } from 'mobx-react';
import React, { useEffect, useState } from 'react';
import Send2AdsManager, { AdvInfo } from '../Send2AdsManager';
import style from './index.module.scss';
import LoginModal from '../../LoginModal';
import { checkSuccessResponse } from '@ad/ad_utils/src/utils/common';
import isArray from 'lodash/isArray';
import type { MAxiosResponse } from '@ad/ad_utils/src/utils/mAxios';
import { AdvAssetsAuthResult } from '../AuthManageConfirmModal/type';

interface Sync2AdsManagerProps {
  getAdvertiserList?: Function;
  sendVideoToTtam?: (req: {
    fileIds: string[];
    advIds: string[];
    shareToken: string;
    permissionType?: AdvAssetsAuthResult;
  }) => Promise<MAxiosResponse<any>>;
  selectedVideos: any[];
  disabled?: boolean;
  shareToken: string;
  store?: any;
  sendCustomEvent?: Function;
  source: string;
  canManuallyAddAdv?: boolean;
  onSearchAdv?: (advId: string) => Promise<AdvInfo[] | undefined>;
}

function Sync2AdsManagerBtn(props: Sync2AdsManagerProps) {
  const {
    selectedVideos,
    shareToken,
    disabled,
    store,
    getAdvertiserList,
    sendVideoToTtam,
    sendCustomEvent,
    source,
    onSearchAdv,
    canManuallyAddAdv
  } = props;
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [showLoginModal, setShowLoginModal] = useState(false);
  const [advDatasource, setAdvDatasource] = useState<{ id: string; name: string }[]>([]);

  const onClick = () => {
    sendCustomEvent?.('asset_management_sync_videos_click', { source });

    if (store.loggedIn === false) {
      sendCustomEvent?.('asset_management_open_login_modal', { source });
      setShowLoginModal(true);
    } else {
      setShowConfirmModal(true);
    }
  };

  async function fetchAdvertiserList() {
    const res = await getAdvertiserList?.();
    if (checkSuccessResponse(res.code)) {
      const isArr = isArray(res.data);
      setAdvDatasource(isArr ? res.data : []);
    }
  }

  useEffect(() => {
    (async () => {
      await fetchAdvertiserList();
    })();
  }, [getAdvertiserList]);

  return (
    <div>
      {/* @ts-ignore */}
      <Button type="primary" onClick={onClick} disabled={disabled} className={style.syncBtn}>
        Sync to Ads Manager
      </Button>
      <LoginModal
        show={showLoginModal}
        loginModalType="login"
        store={store}
        cb={async () => {
          sendCustomEvent?.('asset_management_login_success');
          setShowLoginModal(false);
          await fetchAdvertiserList();
        }}
        onClose={() => setShowLoginModal(false)}
      />
      <Send2AdsManager
        advDatasource={advDatasource}
        sendVideoToTtam={sendVideoToTtam}
        shareToken={shareToken}
        selectedVideos={selectedVideos}
        show={showConfirmModal}
        onClose={() => setShowConfirmModal(false)}
        sendCustomEvent={sendCustomEvent}
        source={source}
        canManuallyAddAdv={canManuallyAddAdv}
        onSearchAdv={onSearchAdv}
      />
    </div>
  );
}

export default observer(Sync2AdsManagerBtn);
